import { RArray } from "../../../collections";
import { Identifier, makeImmutable, } from "../../../core";
export class ProductInstancePackingSubjectId extends Identifier {
    // NOTICE Part order is significant: the backend keys its packaging demand by
    // the ordered list, so "half A / half B" and "half B / half A" are two
    // different packaged products and must not share an id.
    constructor(productTypeIds) {
        super("ProductInstancePackingSubjectId", productTypeIds.raw.join(":"));
    }
}
export class ProductInstancePackingSubject {
    constructor(params) {
        this.type = "ProductInstance";
        this.id = new ProductInstancePackingSubjectId(params.productTypeIds);
        this.productTypeIds = params.productTypeIds;
        this.packagedProductTypeIds = params.packagedProductTypeIds;
        this.volume = params.volume;
        makeImmutable(this);
    }
    eq(other) {
        return (other.type === "ProductInstance" &&
            RArray.eq(this.productTypeIds, other.productTypeIds) &&
            this.packagedProductTypeIds.eq(other.packagedProductTypeIds) &&
            this.volume.eq(other.volume));
    }
}
export class ModifierItemPackingSubject {
    constructor(params) {
        this.type = "ModifierItem";
        this.modifierTypeId = params.modifierTypeId;
        this.modifierItemTypeId = params.modifierItemTypeId;
        this.volume = params.volume;
        makeImmutable(this);
    }
    get id() {
        return this.modifierItemTypeId;
    }
    eq(other) {
        return (other.type === "ModifierItem" &&
            this.modifierTypeId.eq(other.modifierTypeId) &&
            this.modifierItemTypeId.eq(other.modifierItemTypeId) &&
            this.volume.eq(other.volume));
    }
}
